module.exports = {
          srcSet: __webpack_public_path__ + "ca12d01e1eb79040207a22115315b4c1-260.png"+" 260w",
          images:[ {path: __webpack_public_path__ + "ca12d01e1eb79040207a22115315b4c1-260.png",width: 260,height: 91}],
          src: __webpack_public_path__ + "ca12d01e1eb79040207a22115315b4c1-260.png",
          toString:function(){return __webpack_public_path__ + "ca12d01e1eb79040207a22115315b4c1-260.png"},
          
          width: 260,
          height: 91
        }